import React, { useRef } from 'react';

import NftImagePlaceholder from '../../images/nftImagePlaceholder.svg';

type Props = {
  src: string;
  width?: number | string;
  height?: number | string;
  alt?: string;
  className?: string;
};

// TODO_R: [RP] ImageWithNFTPlaceholder
// TODO_R: move into NFTsTab/components
export const ImageWithPlaceholder = ({ src, ...rest }: Props) => {
  const ref = useRef<HTMLImageElement>(null);

  return (
    <img
      src={src}
      alt=""
      onError={(e) => {
        if (ref.current) {
          ref.current.src = NftImagePlaceholder;
        }
      }}
      ref={ref}
      {...rest}
    />
  );
};
